import { Organization } from '@cast/types';

export enum CreateOrganizationAsEnum {
  CHILD = 'child',
  STANDALONE = 'standalone',
}

export type OrganizationFormValues = Pick<Organization, 'name'> & {
  createOrganizationAs?: CreateOrganizationAsEnum;
  enterpriseId?: string;
};
